export const VALUES_FIELD_NAME = [
    'Thin',
    'Thin Italic',
    'Light',
    'Light Italic',
    'Regular',
    'Regular Italic',
    'Medium',
    'Medium Italic',
    'Semi-Bold',
    'Semi-Bold Italic',
    'Bold',
    'Bold Italic',
    'Black',
    'Black Italic',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];
